const settings = {
    map: {
        mapSecurityJsCode: '19ad554f5248b40fcc09d25854db0f6a',
        mapKey: 'd4a544cbce82ad6bf23c00f0dace1546'
    },
    pageSizes: [10, 20, 30, 40]
}

export default settings;
